import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './ItemPreview.module.scss'

const SponsoredLabel = () => {
  const { t } = useSurveyLocale()

  return (
    <div className={style.sponsored}>
      <EmptyLink>
        <span
          className={style.small}
          dangerouslySetInnerHTML={{ __html: t('questions', 'ec', 'amazon', 'sponsored') }}
        />
        <div className={style.helpIcon}></div>
      </EmptyLink>
    </div>
  )
}

export default SponsoredLabel
